import IconSelector from './IconSelector'

export default IconSelector
